import {
  Href,
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
  useRouter,
} from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import theme from 'shared/styles/theme';

const SavingsAgreement = () => {
  const router = useRouter();
  const { agreementTitle, pdfUrl } = useLocalSearchParams<{
    agreementTitle: string;
    pdfUrl: string;
  }>();

  if (!pdfUrl) {
    router.navigate(`/(home)` as Href);
  }
  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          title: agreementTitle,
          headerShown: true,
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <View style={styles.pdfContainer}>
        <PdfViewer url={pdfUrl} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
  pdfContainer: {
    flex: 1,
    marginTop: theme.spacing.s,
  },
});

export default SavingsAgreement;
